module.exports = __webpack_public_path__ + "static/media/blackFull.4ce61338.svg";